import axiosInstance from "../services/AxiosInstance"
import { cachedRequest, clearCache } from "./requestCache"

const API_URL = "/classrooms"

export const getClassrooms = async (limit = 10, page = 1, search = "", searchField = "") => {
  try {
    let url = `${API_URL}?limit=${limit}&page=${page}`;

    if (search && search.trim() !== "") {
      url += `&search=${encodeURIComponent(search)}`;
      if (searchField && searchField !== "all") {
        url += `&searchField=${searchField}`;
      }
    }

    const response = await axiosInstance.get(url);
    return {
      data: response.data.data,
      pagination: response.data.pagination,
    };
  } catch (error) {
    console.error("Error fetching classrooms", error);
    throw error;
  }
};

// Create a new classroom
export const createClassroom = async (classroomData) => {
  try {
    const response = await axiosInstance.post(API_URL, classroomData)
    clearCache("classrooms:")
    return response.data
  } catch (error) {
    console.error("Error creating classroom", {
      error: error.response?.data,
      requestData: classroomData,
    })
    throw error
  }
}

// Update a classroom by ID
export const updateClassroom = async (classroomId, classroomData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${classroomId}`, classroomData)
    clearCache("classrooms:")
    return response.data
  } catch (error) {
    console.error("Error updating classroom", error)
    throw error
  }
}

// Delete a classroom by ID
export const deleteClassroom = async (classroomId) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${classroomId}`)
    clearCache("classrooms:")
    return response.data
  } catch (error) {
    console.error("Error deleting classroom", error)
    throw error
  }
}

/**
 * Load all classrooms by paging in chunks under 50.
 * The backend's list endpoint switches to a broken streaming response whenever
 * the requested page size is >= 50 (AUTO_STREAM_LIMIT), returning a raw Stream
 * object instead of an array. Paging in small chunks avoids that path entirely.
 */
export const fetchAllClassrooms = async (search = "", searchField = "") => {
  const all = [];
  let page = 1;
  const limit = 40;
  const maxPages = 200;
  while (page <= maxPages) {
    const { data } = await getClassrooms(limit, page, search, searchField);
    const chunk = Array.isArray(data) ? data : [];
    if (!chunk.length) break;
    all.push(...chunk);
    if (chunk.length < limit) break;
    page += 1;
  }
  return all;
};

// Get a classroom by ID
export const getClassroomById = async (classroomId) => {
  return cachedRequest(`classrooms:byId:${classroomId}`, 60000, async () => {
    try {
      const response = await axiosInstance.get(`${API_URL}/${classroomId}`)
      return {
        data: response.data.data,
        status: response.status,
        message: response.data.message,
      }
    } catch (error) {
      console.error("Error fetching classroom details", error)
      throw error
    }
  })
}
